<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="HubLogin-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="HubLogin-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="HubLogin-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="HubLogin-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <path class="HubLogin-st2" d="M69.32,44.02c-3.48-3.48-9.12-3.48-12.6,0c-2.71,2.71-3.39,6.86-1.67,10.29L41.23,68.13l-0.01,3.99l7.73,0.01v-3.76h3.76v-3.76h3.76v-3.76l2.56-2.56c4.4,2.2,9.75,0.42,11.95-3.98C72.7,50.88,72.03,46.73,69.32,44.02z M66.49,50.66c-1.05,1.05-2.76,1.05-3.81,0s-1.05-2.76,0-3.81c1.05-1.05,2.76-1.05,3.81,0c0,0,0,0,0,0C67.54,47.91,67.54,49.61,66.49,50.66z"/>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.HubLogin_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.HubLogin_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="HubLogin-wrapper-inputs lxn-margin-auto lxn-border-round">
      <div class="HubLogin-input-spacer">
      </div>
      <customInput v-model="uuid" @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" :placeHolder="$store.getters.language.texts.HubLogin_placeHolder" inputType="text">
      </customInput>
      <div class="HubLogin-input-spacer">
      </div>
      <customInput v-model="password" @focus="input2State='active'" @blur="input2State=''" :inputState="input2State" :placeHolder="$store.getters.language.texts.HubLogin_placeHolder2" inputType="password">
      </customInput>
    </div>
    <div class="HubLogin-button lxn-margin-auto lxn-w100">
      <CustomButton @click="HubLogin" bgColor="#1EA5DE" iconRight="verySecure" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.HubLogin_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomInput from '@/components/CustomInput.vue'
import md5 from 'md5'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'HubLogin',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton,
    CustomInput
  },
  data: function () {
    return {
      hub: this.$store.getters.getHubByUUID(this.$route.params.hubUUID),
      uuid: '',
      password: '',
      input1State: '',
      input2State: ''
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    HubLogin: function () {
      this.input1State = '';
      this.input2State = '';
      var destinationUUID = parseInt(this.uuid, 16);
      if(this.uuid == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.HubLogin_alert1);
      }else if(this.$store.getters.getHubByUUID(destinationUUID) != -1){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.HubLogin_alert3);
      }else if(this.password == ''){
        this.input2State = 'error';
        alert(this.$store.getters.language.texts.HubLogin_alert2);
      }else{
        this.$store.commit('setAppBusy', true);
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: messagingHook.utility.generatePskFromPassword(md5(this.password.toString())),
          destinationUUID: destinationUUID,
          sourceUUID: this.$store.state.user.uuid
        });
        var newPSK = messaging.utility.generateRandomPSK();
        this.$store.dispatch('loginUserToHub', {
          connectionType: 'Local',
          messagingHook: messagingHook,
          hubUUID: destinationUUID,
          bodyContent: {
            psk: newPSK,
          }
        })
        .then( response => {
          this.$store.commit('addHub', {
            name: '0x' + messaging.utility.uuidToHexString(destinationUUID).toUpperCase(),
            color: 0,
            psk: newPSK,
            uuid: destinationUUID,
            ipAddress: null,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
            stateUpdateEnabled: false,
            stateUpdatePending: false,
            isOwner: response.body.bodyContent.isOwner == 1,
            firmWareYear: null,
            firmWareMonth: null,
            isMQTTTConnected: null,
            wifiType: null,
            ssid: null,
            dateStamp: null,
            timeStamp: null,
            networkAddress: null,
            staticIp: false,
            port: 80,
            users: [
              {
                uuid: this.$store.state.user.uuid,
                name: this.$store.getters.language.texts.Hub_User,
                mobile: this.$store.state.user.mobileNumber,
                isOwner: response.body.bodyContent.isOwner == 1,
              },
            ]
          });
          this.$store.commit('saveState');
          this.$store.dispatch('updateHubNodeStatus', destinationUUID);
          this.$router.push('/HubLoginSuccess');
          this.$store.commit('setAppBusy', false);
        })
        .catch( response => {
          if(response.rejectCode == 1){
            this.$router.push('/HubLoginError');
            this.$store.commit('setAppBusy', false);
          }else{
            var messagingHook = new Messaging(new Logger(false));
            messagingHook.init({
              psk: messagingHook.utility.generatePskFromPassword(md5(this.password.toString())),
              destinationUUID: destinationUUID,
              sourceUUID: this.$store.state.user.uuid
            });
            var newPSK = messaging.utility.generateRandomPSK();
            this.$store.dispatch('loginUserToHub', {
              connectionType: 'Online',
              messagingHook: messagingHook,
              hubUUID: destinationUUID,
              bodyContent: {
                psk: newPSK,
              }
            })
            .then( response => {
              this.$store.commit('addHub', {
                name: '0x' + messaging.utility.uuidToHexString(destinationUUID).toUpperCase(),
                color: 0,
                psk: newPSK,
                uuid: destinationUUID,
                ipAddress: null,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
                stateUpdateEnabled: false,
                stateUpdatePending: false,
                isOwner: response.body.bodyContent.isOwner == 1,
                firmWareYear: null,
                firmWareMonth: null,
                isMQTTTConnected: null,
                wifiType: null,
                ssid: null,
                dateStamp: null,
                timeStamp: null,
                networkAddress: null,
                staticIp: false,
                port: 80,
                users: [
                  {
                    uuid: this.$store.state.user.uuid,
                    name: this.$store.getters.language.texts.Hub_User,
                    mobile: this.$store.state.user.mobileNumber,
                    isOwner: response.body.bodyContent.isOwner == 1,
                  },
                ]
              });
              this.$store.commit('saveState');
              this.$store.dispatch('updateHubNodeStatus', destinationUUID);
              this.$router.push('/HubLoginSuccess');
              this.$store.commit('setAppBusy', false);
            })
            .catch( response => {
              if(response.rejectCode == 1){
                this.$router.push('/HubLoginError');
              }else if(response.rejectCode == 2){
                this.$router.push('/HubLoginNotFound');
              }else if(response.rejectCode == 3){
                this.$router.push('/HubLoginNotFound');
              }
              this.$store.commit('setAppBusy', false);
            });
          }
        });
      }
    }
  }
}
</script>

<style>
  .HubLogin-topCurve-wrapper {
    height: 200px;
  }
  .HubLogin-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .HubLogin-wrapper-inputs {
    width: calc(100% - 36px);
    height: 148px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .HubLogin-input-spacer {
    height: 16px;
  }
  .HubLogin-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.HubLogin-st0 {
    fill: #ECECEC;
  }
	.HubLogin-st1 {
    fill: #53636C;
  }
	.HubLogin-st2 {
    fill: #1EA5DE;
  }
</style>
